import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import {apiResendOTP, apiSignIn, apiSignOut, apiSignUp, apiValidateOTP} from 'services/AuthService'
import {onSignInLoggedIn, onSignInSuccess, onSignOutSuccess} from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import {OTP_URL_KEY, REDIRECT_URL_KEY} from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            if (resp.data) {
                dispatch(onSignInSuccess(resp.data))
                dispatch(onSignInLoggedIn());
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)

                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )

                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const resendOTP = async (values) => {
        try {
            const resp = await apiResendOTP(values)
            if (resp.data) {
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const validateOTP = async (values) => {
        try {
            const resp = await apiValidateOTP(values)
            if (resp.data) {
                dispatch(onSignInLoggedIn(resp.data));
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }


    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                dispatch(onSignInSuccess(resp.data))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user
                        )
                    )
                }
                const redirectUrl = query.get(OTP_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.otpPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        console.log("signOut")
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async (values) => {
        const resp = await apiSignOut(values)
        handleSignOut()
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signUp,
        validateOTP,
        resendOTP,
        signOut,
    }
}

export default useAuth
